import {
    REBATE_INSIGHTS,
    REBATE_LOAD,
    REBATE_END,
} from "../../../actions/Customers/Rebates/ActionTypes";
const initialState = {
    rebateLoading: false,
    insightsData: [],
};

const RebatesReducer = (state = initialState, action) => {
    switch (action.type) {
        case REBATE_INSIGHTS:
            return {
                ...state,
                insightsData: action.data,
            };
        case REBATE_LOAD:
            return {
                ...state,
                rebateLoading: true,
            };
        case REBATE_END:
            return {
                ...state,
                rebateLoading: false,
            };
        default:
            return state;
    }
};
export default RebatesReducer;